module.exports = __webpack_public_path__ + "static/media/poll-h.b1311ddd.svg";